import { defineStyleConfig } from '@chakra-ui/react'

export const containerTheme = defineStyleConfig({
	baseStyle: {
		mx: 'auto',
		px: { base: '1.25rem', md: '4rem', xl: '4.25rem' },
		maxWidth: { base: 'container.sm', md: 'container.md', xl: 'container.xl' }
	}
})
